import React, { useState } from "react";
import axios from "axios";
import MicroIcon from "../brand/MicroIcon";
import { COLORS, SITE } from "../brand/tokens";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("ok");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus("error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="site-main site-main--cream" data-testid="page-contact">
      <section className="contact-hero">
        <p className="eyebrow">CONTACT · WE'D LOVE TO HEAR FROM YOU</p>
        <h1>Say hello.</h1>
        <p className="lede">Questions, collaborations, wholesale, or a gentle word — this inbox is always open.</p>
      </section>

      <section className="contact-grid">
        <div className="contact-info">
          <MicroIcon size={60} color={COLORS.gold} />
          <div>
            <p className="eyebrow">GENERAL</p>
            <a href={`mailto:${SITE.email}`} className="contact-info__email">{SITE.email}</a>
          </div>
          <div>
            <p className="eyebrow">SUPPORT</p>
            <a href={`mailto:${SITE.emailSupport}`} className="contact-info__email">{SITE.emailSupport}</a>
          </div>
          <div>
            <p className="eyebrow">FOLLOW</p>
            <div className="contact-info__socials">
              <a href={SITE.socials.instagram} target="_blank" rel="noreferrer">Instagram</a>
              <a href={SITE.socials.tiktok} target="_blank" rel="noreferrer">TikTok</a>
              <a href={SITE.socials.youtube} target="_blank" rel="noreferrer">YouTube</a>
              <a href={SITE.socials.pinterest} target="_blank" rel="noreferrer">Pinterest</a>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={submit} data-testid="contact-form">
          <label className="contact-form__field">
            <span>Your name</span>
            <input
              type="text"
              value={form.name}
              onChange={set("name")}
              required
              data-testid="contact-name"
            />
          </label>
          <label className="contact-form__field">
            <span>Your email</span>
            <input
              type="email"
              value={form.email}
              onChange={set("email")}
              required
              data-testid="contact-email"
            />
          </label>
          <label className="contact-form__field">
            <span>Your message</span>
            <textarea
              rows="5"
              value={form.message}
              onChange={set("message")}
              required
              data-testid="contact-message"
            />
          </label>
          <button type="submit" disabled={busy} className="btn btn--gold" data-testid="contact-submit">
            {busy ? "Sending…" : "Send message"}
          </button>
          {status === "ok" && <p className="contact-form__msg contact-form__msg--ok" data-testid="contact-success">Thank you 🌿 — I'll reply within 2 days.</p>}
          {status === "error" && <p className="contact-form__msg contact-form__msg--err" data-testid="contact-error">Something went wrong. Please email us directly.</p>}
        </form>
      </section>
    </main>
  );
};

export default ContactPage;
